import React, { useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { styled, useTheme } from '@mui/material/styles'
import Box from '@mui/material/Box'
import MuiDrawer from '@mui/material/Drawer'

import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'

import HomeIcon from 'assets/navbar/home.svg'
import ResourcesIcon from 'assets/navbar/resources.svg'
import SocialIcon from 'assets/navbar/social.svg'
import VaultIcon from 'assets/navbar/vault.svg'
import SearchIcon from 'assets/navbar/search.svg'
import SupportIcon from 'assets/navbar/support.svg'
import CheckIcon from 'assets/navbar/formatlistbullet.svg'

const items = [
  {
    path: '/',
    title: 'Home',
    icon: HomeIcon,
  },
  {
    path: '/correct-your-data',
    title: 'Correct Your Data',
    icon: CheckIcon,
  },
  {
    path: '/find',
    title: 'Find a Business',
    icon: SearchIcon,
  },
  {
    path: '/vault-verification',
    title: 'Manage Vault',
    icon: VaultIcon,
  },
  {
    path: '/resources',
    title: 'Partner Solutions',
    icon: ResourcesIcon,
  },
  {
    path: '/social',
    title: 'Social',
    icon: SocialIcon,
  },
  {
    path: 'https://support.markaaz.com/knowledge?_gl=1*2nu3op*_ga*ODIxNjA5MDA4LjE2NTA1ODEzODM.*_ga_ERS8LY82HR*MTY2MDMxNDc5MS4xOTEuMC4xNjYwMzE0NzkxLjYw',
    target: '_blank',
    title: 'Support Center',
    icon: SupportIcon,
  },
]
const drawerWidth = 245

const openedMixin = theme => ({
  width: drawerWidth,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: 'hidden',
})

const closedMixin = theme => ({
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: 'hidden',
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up('sm')]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
})

const Drawer = styled(MuiDrawer, { shouldForwardProp: prop => prop !== 'open' })(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: 'nowrap',
  boxSizing: 'border-box',
  '.MuiDrawer-paper': {
    border: 'none',
    background: theme.palette.background.sidebar,
    color: 'white',
  },
  ...(open && {
    ...openedMixin(theme),
    '& .MuiDrawer-paper': openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    '& .MuiDrawer-paper': closedMixin(theme),
  }),
}))

export default function SideBar(props) {
  const navigate = useNavigate()
  const location = useLocation()
  const theme = useTheme()
  const [open, setOpen] = useState(false)

  return (
    <Box sx={{ display: 'flex' }}>
      <Drawer
        variant="permanent"
        open={open}
        onMouseEnter={() => {
          setOpen(true)
        }}
        onMouseLeave={() => {
          setOpen(false)
        }}
        sx={{
          background: theme.palette.background.sidebar,
          zIndex: theme.zIndex.drawer,
        }}
      >
        <List sx={{ paddingTop: '100px' }}>
          {items.map((item, index) => (
            <ListItem key={item.title} disablePadding sx={{ display: 'block', padding: 0 }}>
              <ListItemButton
                onClick={() => (item.target ? window.open(item.path, item.target) : navigate(item.path))}
                sx={{
                  minHeight: 70,
                  justifyContent: open ? 'initial' : 'center',
                  px: 2.5,
                  background: (location.pathname === item.path  || (item.title === "Manage Vault" && location.pathname === "/vault")) ? theme.palette.background.primary : 'transparent',
                }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: open ? 3 : 'auto',
                    justifyContent: 'center',
                  }}
                >
                  <img
                    src={item.icon}
                    height="25px"
                    width="22.5px"
                    alt={item.title + '-nav-button'}
                    style={{
                      filter:
                        location.pathname === item.path ? 'brightness(2) sepia(0.3) hue-rotate(90deg) saturate(1)' : '',
                    }}
                  />
                </ListItemIcon>
                <ListItemText primary={item.title} sx={{ opacity: open ? 1 : 0 }} />
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      </Drawer>
    </Box>
  )
}
